<template>
    <div class="component-loader">
        <div class="loading-overlay-loader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</template>

<script setup lang="ts">
defineOptions({ name: "ComponentLoader" });
</script>

<style></style>
